<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="550" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center e-Invoice Submission
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      template(v-if="einvoice && einvoice.status_text === 'Invalid'")
        .text-sm.font-medium.danger500--text e-Invoice validation errors:
        ul(v-if="einvoice.error_messages.length")
          template(v-for="(message, index) in einvoice.error_messages")
            li.text-sm.danger500--text(:key="`err-${index}`") {{ message }}
      v-form(ref="form")
        template(v-if="transactions.length")
          div.text-sm.font-semibold.neutral500--text Payments
          .pa-3.rounded-lg.border-solid.border-neutral-400.mt-2
            yz-checkbox-group(v-model="selectedTransactions" direction="vertical" :spacing="8" required required-error-message="Please select at least one transaction")
              template(v-for="(transaction, idx) in transactions")
                v-row(no-gutters align="center" :key="`txn-${idx}`")
                  v-col(cols="auto")
                    yz-checkbox(:value="idx")
                  v-col.pl-3
                    .text-sm.neutral700--text {{ transaction.payment_method }}
                  v-col(cols="auto")
                    .text-sm.font-medium.neutral700--text {{ transaction.amount | displayPrice($currency) }}
            v-divider.neutral400.my-3
            v-row(no-gutters align="center")
              v-col
                .text-sm.font-semibold.neutral700--text Total
              v-col(cols="auto")
                .text-sm.font-semibold.primary--text {{ totalSelectedAmount | displayPrice($currency) }}
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="form.name" :placeholder="$t('name')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4 Identification type
        y-select.mt-2(v-model="form.type" :items="types" item-text="name" item-value="id" placeholder="Identification type" :rules="rules.not_empty_select")
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('nric_passport') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="form.ic" :placeholder="$t('nric_passport')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" maxlength="12")
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
        phone-input.mt-2(v-model="form.phone" required)
        div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('email') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="form.email" :placeholder="$t('email')" outlined dense height="48" hide-details="auto" :rules="Boolean(form.email) || Boolean(form.send_email) ? rules.valid_email : []")
        div.mt-3
          y-checkbox.mb-n2(v-model="form.send_email")
            template(#label)
              .text-sm.neutral700--text Send a copy to patient
        .address
          div.text-sm.font-semibold.neutral500--text.mt-4 Address
          v-text-field.text-sm.mt-2.round-xl(v-model="address.address_1" :placeholder="$t('address_1.label')" outlined dense height="48" :rules="!checkEmptyAddress(address) ? rules.not_empty : []" hide-details="auto")
          v-text-field.text-sm.mt-2.round-xl(v-model="address.address_2" :placeholder="$t('address_2.label')" outlined dense height="48" hide-details="auto")
          v-text-field.text-sm.mt-2.round-xl(v-model="address.postcode" :placeholder="$t('postcode.label')" outlined dense height="48" :rules="!checkEmptyAddress(address) ? rules.not_empty : []" hide-details="auto" @keyup="fetchPostcodes(address.postcode, address)")
          v-text-field.text-sm.mt-2.round-xl(v-model="address.city" :placeholder="$t('city.label')" outlined dense height="48" :rules="!checkEmptyAddress(address) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")
          v-text-field.text-sm.mt-2.round-xl(v-model="address.state" :placeholder="$t('state.label')" outlined dense height="48" :rules="!checkEmptyAddress(address) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")
          v-text-field.text-sm.mt-2.round-xl(v-model="address.country" :placeholder="$t('country.label')" outlined dense height="48" :rules="!checkEmptyAddress(address) ? rules.not_empty : []" hide-details="auto" :loading="isFetchingAddress")

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="sendData" :loading="isLoading" color="primary" depressed) Submit

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  components: { PhoneInput },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    invoice: {
      required: true,
      type: Object,
      default: (() => {})
    },
    einvoice: {
      type: Object,
      default: null
    },
    transactions: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      isFetchingAddress: false,
      isLoading: false,
      selectedTransactions: [],
      form: {},
      address: {},
      types: [
        { id: 'NRIC', name: 'NRIC' },
        { id: 'PASSPORT', name: 'Passport' },
        { id: 'ARMY', name: 'No Tentera' }
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    totalSelectedAmount () {
      return this.transactions.filter((_, idx) => this.selectedTransactions.includes(idx)).reduce((sum, t) => sum + (t.amount || 0), 0)
    },
    patient () {
      return this.invoice.customer
    },
    billingInfo () {
      return this.invoice.billing_address
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.selectedTransactions = this.transactions.map((_, idx) => idx)
      this.form = {
        name: this.einvoice?.result?._request?.customer?.name || this.billingInfo?.name || this.patient?.name || null,
        ic: this.einvoice?.result?._request?.customer?.id_value || this.billingInfo?.extra_data?.relationship?.ic || this.patient?.ic || null,
        type: this.einvoice?.result?._request?.customer?.id_type || this.checkIdentification(this.patient?.ic),
        phone: this.einvoice?.result?._request?.customer?.phone || this.billingInfo?.phone || this.patient?.phone || null,
        email: this.einvoice?.result?._request?.customer?.email || this.billingInfo?.email || this.patient?.email || null,
      }
      this.address = {
        address_1: this.einvoice?.result?._request?.customer?.address?.address_1 || this.billingInfo?.address_1 || this.patient?.address?.address_1 || null,
        address_2: this.einvoice?.result?._request?.customer?.address?.address_2 || this.billingInfo?.address_2 || this.patient?.address?.address_2 || null,
        postcode: this.einvoice?.result?._request?.customer?.address?.postcode || this.billingInfo?.postcode || this.patient?.address?.postcode || null,
        city: this.einvoice?.result?._request?.customer?.address?.city || this.billingInfo?.city || this.patient?.address?.city || null,
        state: this.einvoice?.result?._request?.customer?.address?.state || this.billingInfo?.state || this.patient?.address?.state || null,
        country: this.einvoice?.result?._request?.customer?.address?.country || this.billingInfo?.country || this.patient?.address?.country || null,
      }
    },
    fetchPostcodes (val, address) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${val}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(address, 'city', addresses[0].city)
          this.$set(address, 'state', addresses[0].state)
          this.$set(address, 'country', addresses[0].country)
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isFetchingAddress = false
      })
    },
    checkEmptyAddress (address) {
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
    sendData () {
      if (!this.$refs.form.validate()) {
        return this.showMessage(['error', 'Please fill in all required fields and fix any errors'])
      }
      this.isLoading = true
      const payload = {
        customer: {
          name: this.form.name || '',
          id_value: this.form.ic || '',
          id_type: this.form.type || '',
          phone: this.form.phone || '',
          email: this.form.email || '',
          send_email: this.form.send_email || false,
          address: { 
            address_1: this.address.address_1 || '',
            address_2: this.address.address_2 || '',
            postcode: this.address.postcode || '',
            city: this.address.city || '',
            state: this.address.state || '',
            country: this.address.country || '',
          }
        }
      }
      if (this.checkEmptyAddress(this.address)) {
        payload.customer.address = null
      }
      if (this.totalSelectedAmount) {
        payload.total_amount = this.totalSelectedAmount
      }
      const endpoint = this.isHq ? `/hq/invoices/${this.invoice.pid}/submit_einvoice` : `/invoices/${this.invoice.pid}/submit_einvoice`
      this.$axios.post(endpoint, payload)
        .then(resp => {
          this.showMessage(['success', 'e-Invoice is submitted for review'])
          this.$emit('update:einvoice', resp.data)
          this.showDialog = false
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.length > 0) {
            message = err.response.data[0]
          } else if (err.response.data) {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) { message = data  }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkIdentification (idString) {
      if (!idString) {
        return 'NRIC'
      }
      const cleanId = idString.replace(/[\s-]/g, '');
      const icPattern = /^(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{6}$/;
      const armyPattern = /^MD\d{6,7}$/;

      if (icPattern.test(cleanId)) {
        const year = parseInt(cleanId.substring(0, 2));
        const month = parseInt(cleanId.substring(2, 4));
        const day = parseInt(cleanId.substring(4, 6));
        
        const currentYear = new Date().getFullYear();
        const fullYear = year + (year > (currentYear - 2000) ? 1900 : 2000);
        const date = new Date(fullYear, month - 1, day);
        
        if (date.getMonth() === month - 1 && date.getDate() === day) {
          return 'NRIC'
        }
      }

      if (armyPattern.test(cleanId)) {
        return 'ARMY'
      }
      
      return 'PASSPORT'
    }
  }
}
</script>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>